import declare from 'dojo/_base/declare';
import lang from 'dojo/_base/lang';
import domConstruct from 'dojo/dom-construct';
import domAttr from 'dojo/dom-attr';
import domClass from 'dojo/dom-class';
import domStyle from 'dojo/dom-style';
import on from 'dojo/on';
import Moveable from 'dojo/dnd/Moveable';
import _WidgetBaseSP from 'more/_WidgetBaseSP';
import SelectBox from 'more/SelectBox';
import MultiSelectBox from '../JDM/MultiSelectBox';
import template from './OccurrenceFilters.html?raw';
export default declare("WidgetCollection.Occurrence.OccurrenceFilters", [_WidgetBaseSP], {
        templateString: template,

        occurrenceList: null,
        employee: null,
        filtermode: null,//"OccurrenceEdit",
        sorting: "date_desc",
        searchKey: "",
        _searchTimeout: null,
        //occurrenceList: null, // ist schon im Template
        _submitInProgess: false,
        _request: null,
        _filterresult: null,
        _filterParams: null,
        _lastRequestParameters: null,

        _startupState: "new",
        _startupSteps: [],
        _startupStepsDone: [],

        isExternalEmployee: false,

        startup: function (employeeEntity) {
            //console.log("filters startup", employeeEntity);
            if (typeof (employeeEntity) == "undefined") {
                // erstmal prüfen wer ich bin, damit wir wissen ob das Filterpanel irgendwie reagieren muss (Bearbeiter vs. Melder)
                this._getCurrentEmployee();
            } else {
                this.employee = employeeEntity;
                this.loadOptions();
            }
            this.setFilterVisibility();
            //this.loadOptions();
        },

        _setFiltermodeAttr: function (value) {
            this.filtermode = value;
            //console.debug("filtermode set to " + value, this._startupState);
            this.setFilterVisibility();
            
            if (this._startupState == "ready") {
                this._lastRequestParameters = null;
                this.applyFilters(0);
            }
        },

        _setSortingAttr: function (value) {
            console.log("filter: new sorting", this.sorting, "new:", value);

            if (this.sorting != value) {
                this.sorting = value;

                this.applyFilters();
            }
        },

        _setSearchKeyAttr: function (value) {
            if (value == this.searchKey) {
                return;
            }

            this.searchKey = value;

            if (this._searchTimeout != null) {
                clearTimeout(this._searchTimeout);
                this._searchTimeout = null;
            }

            this._searchTimeout = setTimeout(lang.hitch(this, "applyFilters"), 888);
        },

        setFilterVisibility: function () {

            domClass.add(this.groupEmployeeGroup, "w3-hide");
            domClass.add(this.groupStatus, "w3-hide");
            domClass.add(this.groupBuilding, "w3-hide");
            domClass.add(this.containerLimitToLocation, "w3-hide");
            domClass.add(this.containerLimitToMyExecutions, "w3-hide");

            //console.debug("setFilterVisibility", this.filtermode);

            //if (this._startupState == "ready") {
            //    this.inputOccurrenceStatus.set("value", null);
            //}

            var bShowLimitToLocation = false;
            var bShowEmployeGroups = false;

            if (this.employee != null) {
                if (this.employee.ref_last_location != null) {
                    bShowLimitToLocation = true;
                }
                if (this.isExternalEmployee == true) {
                    bShowEmployeGroups = false; // externe im OccurrenceEdit-Modus verwenden keine MA-Gruppen zur Filterung...
                } else {
                    bShowEmployeGroups = true;
                }
            }

            switch (this.filtermode) {
                case "default":
                    domClass.remove(this.groupStatus, "w3-hide");
                    domClass.remove(this.groupBuilding, "w3-hide");
                    //bShowLimitToLocation = false;
                    bShowEmployeGroups = false;
                    break;

                case "OccurrenceEdit":
                    domClass.remove(this.groupStatus, "w3-hide");
                    domClass.remove(this.groupBuilding, "w3-hide");
                    if (this.isExternalEmployee == true) {
                        domClass.remove(this.containerLimitToMyExecutions, "w3-hide"); // doch fix lassen
                    }
                    
                    break;
            }

            if (bShowLimitToLocation === true) {
                domClass.remove(this.containerLimitToLocation, "w3-hide");
            } else {
                domClass.add(this.containerLimitToLocation, "w3-hide");
            }

            if (bShowEmployeGroups === true) {
                domClass.remove(this.groupEmployeeGroup, "w3-hide");
            } else {
                domClass.add(this.groupEmployeeGroup, "w3-hide");
            }

            if (this._startupState != "ready") {
                //this.inputLimitToLocation.checked = "checked";
            }
        },

        _getFilterSettings: function (presetName) {
            //LoadFilterSettings(string filterMode, string presetName) ...
       
            var url = window.appRoot + "Occurrence/LoadFilterSettings";

            this._request = this.RequestManager.post(
                url,
                {
                    "presetName": presetName,
                    "filterMode": this.filtermode//"OccurrenceEdit",
                },
                lang.hitch(this, "_onGetFilterSettingsResponse"),
                lang.hitch(this, "_onGetFilterSettingsError"),
                false // sync
            );
        },

        _onGetFilterSettingsResponse: function (response) {
            console.log("_onGetFilterSettingsResponse", response);

            if (typeof (response) == "object" && response != null) {

                if (typeof (response.limitToRealEstate) != "undefined") {
                    this.inputLimitToLocation.checked = response.limitToRealEstate == true;
                }

                if (this.isExternalEmployee == true) {
                    if (typeof (response.limitToMyExecutions) != "undefined") {
                        this.inputLimitToMyExecutions.checked = response.limitToMyExecutions == true;
                    }
                }

                if (typeof (response.buildings) != "undefined") {
                    //this.inputMultiBuilding.set("value", response.buildings);
                    this._reloadBuildingList(response.buildings);
                } else {
                    this._reloadBuildingList(true);
                }

                if (typeof (response.employeeGroups) != "undefined") {
                    //this.inputEmployeeGroupMulti.set("value", response.employeeGroups);
                    this._reloadEmployeeGroups(response.employeeGroups);
                } else {
                    this._reloadEmployeeGroups(true);
                }

                if (typeof (response.occurrenceStatusList) != "undefined") {
                    //this.inputOccurrenceStatusMulti.set("value", response.occurrenceStatusList);
                    this._reloadOccurrenceStatusList(response.occurrenceStatusList);
                } else {
                    this._reloadOccurrenceStatusList(true);
                }

                if (typeof (response.maintypesList) != "undefined") {
                    //this.inputOccurrenceStatusMulti.set("value", response.occurrenceStatusList);
                    this._reloadMaintypes(response.maintypesList);
                } else {
                    this._reloadMaintypes(true);
                }
            } else {
                this._onGetFilterSettingsError("no error, just empty settings");
            }

            this.pushStep("filterpreset");
            this.pushStep("limitToMyExecutions");
        },

        _onGetFilterSettingsError: function (error) {
            console.warn("_onGetFilterSettingsError?", error);
            this._reloadBuildingList(true);
            this._reloadOccurrenceStatusList(true);
            this._reloadMaintypes(true);
            this._reloadEmployeeGroups(true);
            this.pushStep("filterpreset");
            this.pushStep("limitToMyExecutions");
        },

        loadOptions: function () {

            if (this.employee != null) {
                this.isExternalEmployee = this.employee.Classname == "Contact_person";
            }

            // Filterwerte vorladen!
            this._getFilterSettings();

            this._startupSteps = [];
            //console.log("filter load options", this.filtermode);
            this._startupState = "loading";
            switch (this.filtermode) {
                case "default":
                    this._startupSteps = ["status", "building", "employeeLocation", "filterpreset", "maintype"];


                    //this.inputOccurrenceStatus._loadListValues(null);
                    //this.inputOccurrenceStatusMulti._loadListValues();
                    //this._reloadBuildingList(null);

                    break;

                case "OccurrenceEdit":
                    this._startupSteps = ["status", "building", "employeeLocation", "filterpreset", "limitToMyExecutions", "maintype"];

                    if (this.employee.Classname != "Contact_person") {
                        this._startupSteps.push("employeeGroup")
                    }
                    //this.inputOccurrenceStatus._loadListValues(null);  
                    //this.inputOccurrenceStatusMulti._loadListValues();


                    if (this.employee != null) {
                        this.set("employee", this.employee);
                    }
                    //this.set
                    break;
            }
            this.setFilterVisibility();
        },

        pushStep: function (name) {
            
            if (this._startupStepsDone.indexOf(name) == -1) {
                this._startupStepsDone.push(name);
            }

            //console.debug("filter push step: " + name,  "needed/done:", this._startupSteps, this._startupStepsDone, this._startupState);

            for (var i = 0; i < this._startupSteps.length; i++) {
                var key = this._startupSteps[i];

                if (this._startupStepsDone.indexOf(key) == -1) {
                    //console.debug("filter: abort - not all steps done");
                    return;
                }
            }

            if (this._startupStepsDone.length < this._startupSteps.length) {
                //console.debug("filter: abort - not all steps done (check2)");
                return;
            }
            
            if( this._startupSteps.length == 0) {
                //console.debug("filter: abort - no steps defined");
                return;
            }

            this.applyFilters(0);
        },

        removeStep: function () {

        },

        postMixInProperties: function () {
            this.inherited(arguments);
        },
        postCreate: function () {
            this.inherited(arguments);

            this._startupStepsDone = [];
        },

        _setOccurrenceListAttr: function (widget) {
            this.occurrenceList = widget;

            if (this._filterresult != null) {
                this.reloadList();
            }
        },

        siteAction: function (action, paramString) {
            // zb ?id=xyz&type=abc
            var paramList = paramString.slice(1);
            // id=xyz&type=abc

            paramList = paramList.split("&");
            // [id=xyz, type=abc]

            if (action.toUpperCase() == "CREATE" && paramList.length == 1) {
                // zb /Occurrence/create?type=000081a5:0000001a

                var param = paramList[0].split("=");
                //console.log(param);
                if (param[0].toUpperCase() == "TYPE") {
                    var occurrenceType = param[1]; // ekus-ID!

                    this.showOccurrenceForm();
                    this.occurrenceForm.inputOccurrenceType.selectedValue = occurrenceType;
                    //console.info("home prefilled type:", this.occurrenceForm.inputOccurrenceType.selectedValue);
                }
            }

        },

        _getCurrentEmployee: function () {

            this.StandbyStart();
            var url = window.appRoot + "Occurrence/GetCurrentEmployeeJSON";

            this.RequestManager.post(
                url,
                {
                },
                lang.hitch(this, "_onGetCurrentEmployeeResponse"),
                lang.hitch(this, function (error) {
                    console.error("current employee fehler", error.message);
                }),
                false // sync
            );
        },

        _onGetCurrentEmployeeResponse: function (response) {
            //console.debug("filter employee loaded", response);
            this.set("employee", response);
        },

        _setEmployeeAttr: function (entity, bSuppressReload) {
            this.employee = entity;
            console.debug("filter employee set", this._startupState, entity );

            if (this._startupState == "new") {
                this.loadOptions();
                return;
            } 
        },

        //_getCurrentEmployeeGroup: function () {
        //    if (this.employee != null) {
        //        var group = this.employee._group;
        //        this._onGetCurrentEmployeeGroupResponse(group);
        //        return;
        //    }

        //    var url = window.appRoot + "Occurrence/GetCurrentEmployeeGroup";

        //    this._request = this.RequestManager.post(
        //        url,
        //        {
        //            jsonParams: null
        //        },
        //        lang.hitch(this, "_onGetCurrentEmployeeGroupResponse"),
        //        lang.hitch(this, "_onGetCurrentEmployeeGroupError"),
        //        false // sync
        //    );
        //},

        _onGetCurrentEmployeeGroupResponse: function (response) {
            this.StandbyStop();
            console.log("filter _onGetCurrentEmployeeGroupResponse", response);
            //this.inputEmployeeGroup._loadListValues(response);       
            //this.inputEmployeeGroupMulti._loadListValues(response); // 2021-02-01: brauchen wir inzwischen nicht mehr, es sollen die letzten eingestellten Werte befüllt werden
        },

        _onGetCurrentEmployeeGroupError: function (error) {
            // dann einfach ohne Preset weitermachen
            //this.inputEmployeeGroup._loadListValues(); 
            //this.inputEmployeeGroupMulti._loadListValues(); // 2021-02-01: brauchen wir inzwischen nicht mehr
        },

        _onChangeOccurrenceStatus: function (selectedValue) {

            //console.debug("_onChangeOccurrenceStatus", selectedValue);
            this.pushStep("status");
            //this.applyFilters();

        },

        _onChangeOccurrenceStatusMulti: function (selectedValue) {

            console.debug("_onChangeOccurrenceStatusMulti", selectedValue);
            this.pushStep("status");
            //this.applyFilters();

        },

        _onChangeBuilding: function (selectedValue) {

            //console.debug("_onChangeBuilding", selectedValue);
            this.pushStep("building");
            //this.applyFilters();

        },

        _onChangeLimitToMyExecutions: function (selectedValue) {

            //console.debug("_onChangeBuilding", selectedValue);
            this.pushStep("containerLimitToMyExecutions");
            //this.applyFilters();

        },

        

        _onChangeBuildingMulti: function (value) {
            //console.debug("_onChangeBuildingMulti", value);
            this.pushStep("building");
        },


        _onChangeEmployeegroupMulti: function (selectedValue) {

            //console.debug("_onChangeEmployeegroupMulti", selectedValue);
            this.pushStep("employeeGroup");
            //this.applyFilters();
        },
        _onChangeMaintypeMulti: function (selectedValue) {

            //console.debug("_onChangeMaintypeMulti", selectedValue);
            this.pushStep("maintype");
            //this.applyFilters();
        },

        _onChangeLimitToLocation: function (evt) {
            //var newPreset = this.inputLimitToLocation.checked == true ? 
            this._reloadBuildingList(this.inputMultiBuilding.get("value"));

            //this.applyFilters();
        },

        _reloadOccurrenceStatusList: function (presetStatuslist) {
            if (presetStatuslist) {
                if (presetStatuslist.length == 0) {
                    presetStatuslist = true; // ALLES selektieren
                }
            }
            this.inputOccurrenceStatusMulti._loadListValues(presetStatuslist);
        },
        _reloadMaintypes: function (preset) {
            if (preset) {
                if (preset.length == 0) {
                    preset = true; // ALLES selektieren
                }
            }
            this.inputMaintypeMulti._loadListValues(preset);
        },

        _reloadEmployeeGroups: function (preset) {
            if (preset) {
                if (preset.length == 0) {
                    preset = true; // ALLES selektieren
                }
            }
            this.inputEmployeeGroupMulti._loadListValues(preset);
        },

        _reloadBuildingList: function (presetBuildings) {

            var jsonData = {};

            if (this.employee == null) {
                jsonData = { "limitToRealEstate": false };
            }
            else {
                jsonData = { "limitToRealEstate": this.inputLimitToLocation.checked == true, "employee": { "ID": this.employee.ID }
                };
            }
            //console.log("reload Buildinglist", jsonData, this._startupStepsDone);

            var label = this.translations["General_DropdownBlank_All_FromX"];
            if (jsonData.limitToRealEstate != true) {
                label = this.translations["General_DropdownBlank_All"];
            }
            //this.inputBuilding.setRequestParameter("jsonData", JSON.stringify(jsonData));
            //this.inputBuilding.set("blankOption", true, null, label.format(this.employee.ref_last_location.tmp_label));
            //this.inputBuilding._loadListValues(presetBuilding);

            if (presetBuildings) {
                if (presetBuildings.length == 0) {
                    presetBuildings = true; // ALLES selektieren
                }
            }
            if (typeof (presetBuildings) == "undefined" || presetBuildings == null) {
                presetBuildings = true; 
            }
            

            this.inputMultiBuilding.setRequestParameter("jsonData", JSON.stringify(jsonData));
            this.inputMultiBuilding._loadListValues(presetBuildings);
        },

        _getSerializedFilterParams: function () {
            return {
                employeeGroups: this.inputEmployeeGroupMulti.get("value"),
                //occurrenceStatus: this.inputOccurrenceStatusMulti.get("value")[0],
                occurrenceStatusList: this.inputOccurrenceStatusMulti.get("value"),
                //building: this.inputMultiBuilding.get("value")[0],
                buildings: this.inputMultiBuilding.get("value"),
                limitToRealEstate: this.inputLimitToLocation.checked == true,
                limitToMyExecutions: this.inputLimitToMyExecutions.checked == true,
                maintypesList: this.inputMaintypeMulti.get("value")

            };
        },

        applyFilters: function (offset, countLimit) {
            //console.log("apply filters", this._startupState, offset, countLimit);

            if (this._searchTimeout != null) {
                clearTimeout(this._searchTimeout);
                this._searchTimeout = null;
            }

            this._startupState = "ready";
            //this.StandbyStart();

            if (typeof (countLimit) != "number") {
                countLimit = this.occurrenceList._maxResponseCount;
            }
            if (typeof (offset) != "number") {
                offset = 0;
            }

            // Filterparameter in Objekt zusammenstellen
            var valueSorting = this.sorting;

            var filterParams = this._getSerializedFilterParams();

            filterParams._countLimit = countLimit;
            filterParams._offset = offset;
            filterParams.sorting = valueSorting;
            filterParams.searchKey = this.searchKey;            

            //var strFilterParams = JSON.stringify(filterParams);
            //if (this._filterParams == strFilterParams) {
            //    //console.debug("apply filters: no change, list will not reload");
            //    return;
            //} else {
            //    this._filterParams = strFilterParams;
            //    console.debug("apply filters and load list");
            //}

            var stringParams = JSON.stringify(filterParams);
            if (this._lastRequestParameters == stringParams) {
                console.warn("duplicate request from filter!", filterParams);
                return;
            }

            //console.debug("filter: load list", filterParams);

            if (this._request != null) {
                this._request.cancel();
                this.StandbyStop();
            }

            this._lastRequestParameters = stringParams;

            domAttr.set(this.occurrenceList.loadMessage, "innerHTML", "lädt...");
            this.occurrenceList.StandbyStart();

            var url = window.appRoot + "Occurrence/LoadOccurrenceListJSON";

            this._request = this.RequestManager.post(
                url,
                {
                    sJsonData: stringParams,
                    mode: this.filtermode//"OccurrenceEdit",
                },
                lang.hitch(this, "_onLoadOccurrencesResponse", offset, stringParams),
                lang.hitch(this, "_onLoadOccurrencesError"),
                false // sync
            );
        },

        _onLoadOccurrencesResponse: function (offset, stringParams, response) {
            //this.StandbyStop();
            
            this._filterresult = response;//JSON.parse(response);

            //console.debug("reloaded occurrences", JSON.parse(response), this.occurrenceList);
            //this._saveFilterSettings(stringParams); // -> wird in der LoadOccurrences-API gleich mitgemacht, spart den Extrarequest..

            this.reloadList(offset);
        },

        _onLoadOccurrencesError: function (error) {
            this.StandbyStop();
            this.occurrenceList.StandbyStop();
            alert("Loading failed - please try again\r\n" + error.Message);
            console.error("_onLoadOccurrencesError", error.Message);
        },
        // LoadFilterSettings(string filterMode, string presetName)
        _saveFilterSettings: function (rawParams, presetName) {
            var url = window.appRoot + "Occurrence/SaveFilterSettings";

            this._request = this.RequestManager.post(
                url,
                {
                    "presetName": presetName,
                    "jsonData": rawParams,
                    "filterMode": this.filtermode//"OccurrenceEdit",
                },
                lang.hitch(this, "_onSaveFilterSettingsResponse"),
                lang.hitch(this, "_onSaveFilterSettingsError"),
                false // sync
            );
        },

        _onSaveFilterSettingsResponse: function (response) {
            console.info("filter settings saved!");
        },

        _onSaveFilterSettingsError: function (error) {
            console.warn("_onSaveFilterSettingsError", error.message);
        },

        reloadList: function (offset) {
            if (this.occurrenceList == null) {
                return;
            }

            if (offset > 0) {
                this.occurrenceList._onLoadAddedOccurrencesResponse(this._filterresult, offset);
            } else {
                this.occurrenceList._onLoadOccurrencesResponse(this._filterresult);
            }
        },
    });
